import React, { useEffect, useState } from 'react';
import { Stack, Typography, Divider } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { getHistoryById } from '../../../api/historyService';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import PostsList from '../lists/PostsList';
import ProceduresList from '../lists/ProceduresList';
import LatestVitals from '../display/LatestVitals';
import RequirePermission from '../../RequirePermission';
import { SUB_MODULES } from '../../../constants/subModulesConstants';

export default function PatientHistoryView ({ open, onClose, history = null }) {

    const handleClose = () => {
      setSelectedHistory(null);
      onClose();
    };

    const [selectedHistory, setSelectedHistory] = useState(null);

    const [updateFlag, setUpdateFlag] = useState(false);

    const fetchData = async () => {
      const res = await getHistoryById(history.id);
      setSelectedHistory(res);

      // Toggle the flag
      setUpdateFlag(prev => !prev);
    };

    const [docListRefreshKey, setDocListRefreshKey] = useState(0);
    const refreshDocumentationList = () => {
      setDocListRefreshKey(prev => prev + 1);
    };

    useEffect(() => {
        if (open && history) fetchData();
    }, [open]);

    if (!selectedHistory) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
                <>
                <Typography variant="body2" sx={{ mt: 0 }}>{`case no. ${selectedHistory.case_number}`}</Typography>
                <Typography variant="h6" color='primary' component="span" sx={{ mb: 0 }}>{`${selectedHistory.pet.name} (${selectedHistory.pet.owner.first_name} ${selectedHistory.pet.owner.last_name})`}</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{formatToLocalDateTime(selectedHistory.datetime)}</Typography>
                <Typography variant="body2" sx={{ mt: 0, color: 'gray' }}>{`created by ${selectedHistory.user.name}`}</Typography>
                <LatestVitals
                  updateFlag={updateFlag}
                  pet={selectedHistory.pet}
                  history={selectedHistory}
                />
                </>
            </DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2}>
                  <RequirePermission subModuleName={SUB_MODULES.PROCEDURES} minAccessLevel={1}>
                    <ProceduresList 
                      refreshDocumentationList={refreshDocumentationList}
                      fetchData={fetchData}
                      history={selectedHistory}
                      border={true}
                    />
                  </RequirePermission>
                  <RequirePermission subModuleName={SUB_MODULES.NOTES} minAccessLevel={1}>
                    <PostsList 
                      fetchData={fetchData}
                      history={selectedHistory}
                      posts={selectedHistory.posts} 
                      label='Primary Complaint/Notes'
                    />
                  </RequirePermission>
                </Stack>
            </DialogContent>
            <DialogActions>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}